import { ReactNode, useReducer } from "react";
import { AppContext } from "./AppContext";
import { appReducer, initialState } from "./reducer";


export function AppProvider({ children }: { children: ReactNode; }) {
  const [state, dispatch] = useReducer(appReducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
}
